import { resources }                                  from '@kiroku/api';
import useReportCondition                             from '../makeReport/useReportCondition';
import React, { useEffect }                           from 'react';
import { removeConditionsUndefined }                  from '../../Converter';
import momentTZ                                       from 'moment-timezone';
import { KirokuButton, KirokuLoader, SearchNotFound } from '../../../ui';
import If                                             from '../../If';
import { checkUseHeadingQuestion }                    from './index';
import '../report.css';
import { useTranslation }                             from 'react-i18next';

const renderQuestion = (answer) => {
    switch (answer.type) {
        case 'Media':
            return (
                <div className="pb-3">
                    <img className="report-tab" src={ answer.answer } alt=""/>
                </div>
            );
        case 'YesNo':
        case 'Date':
            return (<div className="answer-content">{ answer.answer }</div>);
        default:
            return (<div className="answer-content">{ answer.answer }</div>);
    }
};

const Template = ({ reports }) => (
    <div className="report-tab container">
        <div className="wrap-content">
            <div className="A4">
                <div className="content">
                    <div className="wrap-bg">
                        { reports.customers.map((customer, index) => {
                            return (
                                <div className="pb-5" key={ index }>
                                    <div>
                                        <label className="report-tab">
                                            { reports.translate_customerName }
                                        </label>
                                        <div className="border-title-template">
                                            { customer.customerName }
                                        </div>
                                    </div>
                                    { customer.records.map((record, index) => {
                                        return (
                                            <div key={ index }>
                                                <div className="pb-2 pt-3">
                                                    <label className="report-tab">
                                                        { reports.translate_title }
                                                    </label>
                                                    <div className="border-customer-name">
                                                        { record.title }
                                                    </div>
                                                </div>
                                                { record.questions.map((question, index) => {
                                                    return (
                                                        <div className="" key={ index }>
                                                            <div className="pb-2 pt-3">
                                                                { checkUseHeadingQuestion(question) }
                                                            </div>
                                                            <div className="row ml-0 mr-0 ">
                                                                <div className="col-3 pl-0 ">
                                                                    <label className="report-tab">
                                                                        { reports.translate_serviced }
                                                                    </label>
                                                                </div>
                                                                <div className="col-3 ">
                                                                    <label className="report-tab">
                                                                        { reports.translate_created_by }
                                                                    </label>
                                                                </div>
                                                                <div className="col-6 ">
                                                                    <label className="report-tab">
                                                                        { reports.translate_answer }
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="answers-list">
                                                                { question.answers.map((answer, index) => {
                                                                    return (
                                                                        <div
                                                                            className={ `pt-2 pb-2 row ml-0 mr-0 answer-item ${ answer.answerEnd ? 'end-answer' : 'answer' }` }
                                                                            key={ index }>
                                                                            <div className="col-3 pl-0">
                                                                                { answer.serviced_date_time }
                                                                            </div>
                                                                            <div className="col-3  ">
                                                                                { answer.record_by }
                                                                            </div>
                                                                            <div className="col-6  ">
                                                                                { renderQuestion(answer) }
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }) }
                                                            </div>
                                                        </div>
                                                    );
                                                }) }
                                            </div>
                                        );
                                    }) }
                                </div>
                            );
                        }) }
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default function CustomerQuestion() {

    const { search, result, loading } = resources.useSearch('Report');
    const { condition, print }        = useReportCondition();
    const { t }                       = useTranslation();

    useEffect(() => {
        if (condition) {
            removeConditionsUndefined(condition);
            search({
                type    : 'report',
                template: 'CustomerQuestion',
                lang    : localStorage.getItem('i18nextLng') || 'ja',
                timezone: momentTZ.tz.guess(),
                ...condition,
            });
        }
    }, [search, condition]);

    return (
        <KirokuLoader loading={ loading }>
            <If statement={ result.customers && result.customers.length } otherwise={ <SearchNotFound
                message={t(`Export.showResultSearch`)}
                description={t(`Export.TrySearch`)}
            /> }>
                { () => (
                    <div>
                        <div className="d-flex pt-2 justify-content-end pr-10">
                            <div className="p-2"/>
                            <KirokuButton color={ 'primary' } onClick={ () => print('CustomerQuestion') }>
                                { t('common.print') }
                            </KirokuButton>
                        </div>
                        <Template reports={ result }/>
                    </div>
                ) }
            </If>
        </KirokuLoader>
    );
}
